import React from 'react';
import { numberWithCommas, isMobileIOS} from '../../library/calc';
import { Text, Image } from 'react-konva';
import { fontFamily, isDevelopment, cachetree } from '../../library/constants';
import { animateToFocusThenFetchTreeSaga, isMobilePhone } from '../../library/calc';


const adjustTop = -8.5;
const adjustLeft = 70;

class Icon extends React.Component {

    constructor(props){
      super(props);
      this.props.buildRefObj({key: `prune_n-${this.props.n}`, objClass: this});
    }

    componentDidUpdate(){
      if(cachetree){
        this.refs.pruneNodeCache.cache();
      }
    }

    click(){

      let {
        pr_id,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        node,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        resetNavDirectionControls,
        hideProductTour,
        unhighlight,
      } = this.props;

      if(isMobilePhone() ) return;
      resetNavDirectionControls();
      hideProductTour({fromWhere: 'E', withLastStepNotify: true});
      unhighlight();
      animateToFocusThenFetchTreeSaga({
        pr_id,
        node,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        resetNavDirectionControls,
      });
    }

    render() {
      let {
        left,
        top,
        baretreeImg,
        pr_id,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        node,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        cursorBecomesMove,
        cursorBecomesPointer,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        resetNavDirectionControls,
        hideProductTour,
        unhighlight,
      } = this.props;

      left += adjustLeft - 6.6;
      top += adjustTop + .5;

      return (
          <Image
            ref={'pruneNodeCache'}
            image={baretreeImg}
            scaleX={.1}
            scaleY={.1}
            width={14 * 10}
            height={14 * 10}
            x={left}
            y={top}

            onTouchStart={(e)=>{
              resetNavDirectionControls();
              hideProductTour({fromWhere: 'D', withLastStepNotify: true});
              unhighlight();
              animateToFocusThenFetchTreeSaga({
                pr_id,
                node,
                setPrId,
                fetchTree,
                callSetPageProfile,
                setDidRequestLoadTreeToTrue,
                setStageClickCanZoomStep,
                unSetStageClickCanZoomStep,
                panAnimateToNode,
                setNextNodeForPruning,
                setPushToHistory,
                reloadWithNewTree,
                zoomOutFromMobileFlipCard,
                showProgressIndicator,
                toggleFlipPanel,
                userTouchedNode,
                setFlipPanelOpenAfterAnimateComplete,
                toggleNavigationalPanel,
                resetNavigationState,
                resetNavDirectionControls,
              });
            }}
            onClick={this.click.bind(this)}
            onMouseenter={()=>{
              cursorBecomesPointer();
            }}
            onMouseleave={()=>{
              cursorBecomesMove();
            }}
          />
      );
    }
}

const PruneCount = ({
    p,
    nm,
    n,
    left,
    top,
    pr_id,
    setPrId,
    fetchTree,
    callSetPageProfile,
    setDidRequestLoadTreeToTrue,
    unSetStageClickCanZoomStep,
    setStageClickCanZoomStep,
    panAnimateToNode,
    node,
    setNextNodeForPruning,
    setPushToHistory,
    reloadWithNewTree,
    zoomOutFromMobileFlipCard,
    showProgressIndicator,
    toggleFlipPanel,
    userTouchedNode,
    cursorBecomesMove,
    cursorBecomesPointer,
    setFlipPanelOpenAfterAnimateComplete,
    toggleNavigationalPanel,
    resetNavigationState,
    resetNavDirectionControls,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    hideProductTour,
    unhighlight,
  }) => {

    left += adjustLeft - 7.5;
    // top += adjustTop + 1.7;
    top += adjustTop + ( isMobileIOS() ? 3.7 :4);
    p = ( parseInt(p, 10) > 999 ? '+' + numberWithCommas(parseInt(p, 10)): p);

    return <Text
      x={left}
      y={top}
      text={p}
      fontSize={4}
      fontFamily={fontFamily}
      fill='white'
      width={16}
      align={`center`}
      onClick={()=>{
        if(isMobilePhone() ) return;
        resetNavDirectionControls();
        hideProductTour({fromWhere: 'F', withLastStepNotify: true});
        unhighlight();
        animateToFocusThenFetchTreeSaga({
          pr_id,
          node,
          setPrId,
          fetchTree,
          callSetPageProfile,
          setDidRequestLoadTreeToTrue,
          setStageClickCanZoomStep,
          unSetStageClickCanZoomStep,
          panAnimateToNode,
          setNextNodeForPruning,
          setPushToHistory,
          reloadWithNewTree,
          zoomOutFromMobileFlipCard,
          showProgressIndicator,
          toggleFlipPanel,
          userTouchedNode,
          setFlipPanelOpenAfterAnimateComplete,
          toggleNavigationalPanel,
          resetNavigationState,
          resetNavDirectionControls,
        });
      }}

      onTouchStart={(e)=>{
        resetNavDirectionControls();
        hideProductTour({fromWhere: 'G', withLastStepNotify: true});
        unhighlight();
        animateToFocusThenFetchTreeSaga({
          pr_id,
          node,
          setPrId,
          fetchTree,
          callSetPageProfile,
          setDidRequestLoadTreeToTrue,
          setStageClickCanZoomStep,
          unSetStageClickCanZoomStep,
          panAnimateToNode,
          setNextNodeForPruning,
          setPushToHistory,
          reloadWithNewTree,
          zoomOutFromMobileFlipCard,
          showProgressIndicator,
          toggleFlipPanel,
          userTouchedNode,
          setFlipPanelOpenAfterAnimateComplete,
          toggleNavigationalPanel,
          resetNavigationState,
          resetNavDirectionControls,
        });
      }}

      onMouseenter={()=>{

        const content = ( isDevelopment ? 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ': `View {profile}'s branch of the tree.`)

        showToolTipFor({
          node: n,
          placement: 'over',
          shiftLeftOnToolTip: 64.5,
          shiftTopOnToolTip: -3,
          content,
          runTranslatePhraseInToolTip: true,
          translateVarStrInToolTip: nm,
        })

        cursorBecomesPointer();
      }}
      onMouseleave={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}

    />;
  };

export default ({
    p,
    n,
    nm,
    vsum,
    left,
    top,
    pruneImg,
    baretreeImg,
    pr_id,
    setPrId,
    fetchTree,
    callSetPageProfile,
    setDidRequestLoadTreeToTrue,
    unSetStageClickCanZoomStep,
    setStageClickCanZoomStep,
    panAnimateToNode,
    node,
    setNextNodeForPruning,
    setPushToHistory,
    reloadWithNewTree,
    zoomOutFromMobileFlipCard,
    showProgressIndicator,
    toggleFlipPanel,
    userTouchedNode,
    cursorBecomesMove,
    cursorBecomesPointer,
    setFlipPanelOpenAfterAnimateComplete,
    toggleNavigationalPanel,
    resetNavigationState,
    resetNavDirectionControls,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    hideProductTour,
    unhighlight,
    buildRefObj,
    callRefObj,
  }) => {


  // const pruneImg = new window.Image();
  // pruneImg.src = imageBasePath + 'prunetree.svg';

  const props = {
    p,
    n,
    nm,
    left,
    top,
    pruneImg,
    baretreeImg,
    pr_id,
    setPrId,
    fetchTree,
    callSetPageProfile,
    setDidRequestLoadTreeToTrue,
    unSetStageClickCanZoomStep,
    setStageClickCanZoomStep,
    panAnimateToNode,
    node,
    setNextNodeForPruning,
    setPushToHistory,
    reloadWithNewTree,
    zoomOutFromMobileFlipCard,
    showProgressIndicator,
    toggleFlipPanel,
    userTouchedNode,
    cursorBecomesMove,
    cursorBecomesPointer,
    setFlipPanelOpenAfterAnimateComplete,
    toggleNavigationalPanel,
    resetNavigationState,
    resetNavDirectionControls,
    translatedLabels,
    showToolTipFor,
    hideToolTip,
    hideProductTour,
    unhighlight,
    buildRefObj,
    callRefObj,
  };
  return [
      <Icon key={Math.random()} {...props} />,
      <PruneCount key={Math.random()} {...props} />,
    ]
};

